export enum ViewMode {
  List = 'list',
  Map = 'map',
}
